// extracted by mini-css-extract-plugin
module.exports = {"cardCollectionCard":"CardCollection_cardCollectionCard__p18fI","slide":"CardCollection_slide__WpRYq"};